/**
 * Angular imports.
 */
import { HostListener, Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

/**
 * Service imports.
 */
import { DefaultMediaService } from '../../dataservices/defaultthumbnail/default-media.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';


export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37
}

/**
 * Library imports.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';

/**
 * Importing value of product types
 */
import { PRODUCT_TYPE_CONSTANT } from './../../constants/app.constants';

/**
 * MediaModal Component
 */
@Component({
  selector: 'app-media-modal',
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.scss']
})


export class MediaModalComponent implements OnInit, OnChanges {
  @Input() callingfrom;
  @Output() resetMediaModal = new EventEmitter();
  @Input() isMediaModalShown: boolean;
  @Input() mediaObj;
  @Input() openMediaIndex;

  /**
   * receive input of product type
   */
  @Input() pType: number;

  /**
   * variable for product type
   */
  public productType = PRODUCT_TYPE_CONSTANT;
  public media_msg: string;
  pdfSrc1: string | Uint8Array | null = null;

  public i = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public temp: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public pdfscr1: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public reInitialize_pdf: any;
  public flag = 0;
  public mediaIndex = 0;
  public key: string;
  public last_index = { relatedTarget: 0 };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public bitrates: any = [1000, 500, 200];
  public useractivity = false;
  public keyboard = false;

  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      600: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
    autoHeight: true
  };

  /**
   * Necessary instances.
   */
  constructor(
    public masterService: MasterserviceService,
    public igs: ImageGroupService,
    public defaultMediaService: DefaultMediaService
  ) { }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    this.mediaIndex = this.openMediaIndex;
  }

  /**
   * window:keyup
   */
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    // tslint:disable-next-line: deprecation
    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      this.useractivity = !this.useractivity;
      this.openMediaIndex = this.mediaIndex + 1;
      this.log(this.openMediaIndex);

    }

    // tslint:disable-next-line: deprecation
    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      this.useractivity = !this.useractivity;
      this.openMediaIndex = this.mediaIndex - 1;
      this.log(this.openMediaIndex);
    }
  }

  /**
   * log
   */
  log(event: number): void {
    const dom = (document.querySelectorAll<HTMLElement>('.carousel-item'));
    dom.forEach(el => el.removeAttribute('style'));
    this.useractivity = !this.useractivity;
    this.reInitialize_pdf = this.mediaObj[event];
    if (this.reInitialize_pdf != undefined) {
      this.mediaIndex = this.openMediaIndex;
      if (this.reInitialize_pdf.media_type === 'document' || this.reInitialize_pdf.media_type == 'pdf') {
        this.pdfSrc1 = this.reInitialize_pdf.media_url;
      }
    } else {
      this.useractivity = !this.useractivity;
      this.mediaIndex = 0;
      this.openMediaIndex = 0;
      this.log(this.openMediaIndex);
    }
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.mediaIndex = this.openMediaIndex;

    if (this.mediaObj[0].media_type === 'document' || this.mediaObj[0].media_type == 'pdf') {
      this.pdfSrc1 = this.mediaObj[0].media_url;


    } else if (this.mediaObj[0].media_type === 'documentEdit') {
      this.pdfSrc1 = this.mediaObj[0].media_url;
    } else if (this.mediaObj[0].media_type === 'documentPost') {
      if (typeof (FileReader) !== 'undefined') {
        const reader = new FileReader();
        this.pdfSrc1 = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reader.onload = (e: any) => {
          const arrayBuffer = e.target?.result as ArrayBuffer;
          this.pdfSrc1 = new Uint8Array(arrayBuffer);
        };
        reader.readAsArrayBuffer(this.mediaObj[0].media_url);
      }
    }

    if (this.isMediaModalShown === true) {

      if (!this.mediaObj || this.mediaObj !== null) {
        this.media_msg = 'Oops Something went wrong';
      }
      this.showModal();
    }
  }

  /**
   * reset media modal, emitting to modal
   */
  resetMediaMsgModal(): void { this.resetMediaModal.emit(false); }

  /**
   * show modal
   */
  showModal(): void {
    this.isMediaModalShown = true;
  }

  /**
   * show modal
   */
  hideModal(): void {
    this.isMediaModalShown = false;
    this.resetMediaMsgModal();
  }

  /**
   * show modal
   */
  onHidden(): void {
    this.isMediaModalShown = false;
    this.resetMediaMsgModal();
  }

  /**
   * set slidercls
   */
  setslidercls(): void {

    document.getElementById('mdbcr')?.focus();
    const carouselPrev = (document.querySelectorAll<HTMLElement>('.carousel-control-prev'));
    carouselPrev.forEach(el => el?.classList?.add('leftRs', 'cursor-pointer', 'feed-arrow-pos'));
    const carouselNext = (document.querySelectorAll<HTMLElement>('.carousel-control-next'));
    carouselNext.forEach(el => el?.classList?.add('rightRs', 'cursor-pointer', 'feed-arrow-pos'));
    const carouselNextIcon = (document.querySelectorAll<HTMLElement>('.carousel-control-next-icon'));
    carouselNextIcon.forEach(el => el?.classList?.add('ic-bg-right', 'text-white', 'ic-ms-r'));
    const carouselPrevIcon = (document.querySelectorAll<HTMLElement>('.carousel-control-prev-icon'));
    carouselPrevIcon.forEach(el => el?.classList?.add('ic-bg-left', 'text-white', 'ic-ms-l'));
    this.keyboard = true;
  }
}
